import {StadiumModel} from "../Models/StadiumModel";

export const authMock: {token: string, stadium: StadiumModel} = {
    token: "79c7783a4e051e186bd14339cb2a5fabb32072eb1ed73ff56930a675509288dfe38d91526412578b1c90db2299d1e4c67072104d26a8ae8cf6eb6c92",
    stadium: {
        id: 2,
        reference: "PDA",
        name: "Paris La D\u00e9fense Arena",
        image: "https:\/\/bart.topivo-api.agence2web.com\/v1\/public\/cache\/stadium_image\/images\/stadium\/608fcc27329ce_logo_paris_la_defense_arena_2018.png",
        doors: [
            {
                id: "1",
                name: "100"
            },
            {
                id: "2",
                name: "101"
            }
        ]
    }
}
